/**
 * @component OrganizationChart
 * @description 대표이사 → 경영지원팀/부문 → 팀 계층을 시각적 트리로 렌더링하는 조직도 컴포넌트입니다.
 * @usage CompanyAboutPage 조직도 섹션에서 사용됩니다.
 */

import { organizationChart } from '../../constants/companyData';

export default function OrganizationChart() {
  const { root, support, divisions } = organizationChart;

  return (
    <div className="org-board">
      <div className="org-content">
        {/* 대표이사 */}
        <div className="org-row org-row-root">
          <div className="org-node is-root">
            <div className="org-node-name">{root.name}</div>
            <div className="org-node-sub">{root.subtitle}</div>
          </div>
        </div>

        {/* 수직 연결선 */}
        <div className="org-stem-vertical" />

        {/* 경영지원팀 — 본선에서 측면으로 분기 */}
        <div className="org-support-wrap">
          <div className="org-support">
            <div className="org-node">
              <div className="org-node-name">{support.name}</div>
              <div className="org-node-sub">{support.subtitle}</div>
            </div>
          </div>
        </div>

        {/* 부문 그리드 */}
        <div className="org-divisions">
          {divisions.map((div) => (
            <div
              key={div.name}
              className="org-div-col"
              style={{ '--accent': div.accent }}
            >
              <div className="org-div-node">
                <div className="org-node-name">{div.name}</div>
                <div className="org-node-sub">{div.subtitle}</div>
              </div>
              {div.children?.length > 0 && (
                <ul className="org-teams">
                  {div.children.map((team) => (
                    <li key={team} className="org-team">{team}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
